const SET_CHANNEL_JOURNAL_LIST = '@channel-journal/set-channel-journal-list';
const SET_CHANNEL_JOURNAL_DETAIL = '@channel-journal/set-channel-journal-detail';
const SET_CHANNEL_JOURNAL_LIST_TOTAL = '@channel-journal/set-channel-journal-list-total';

export {SET_CHANNEL_JOURNAL_LIST, SET_CHANNEL_JOURNAL_DETAIL, SET_CHANNEL_JOURNAL_LIST_TOTAL};